// @import_dependencies
import { store } from 'app_storage/redux-storage'
// @end

// @import services
import { Http, HttpCustomStructure } from 'app_utils/http'
// @end

// @import utilities
import {IBulkUploadEndpoint} from 'app_types/admin/bulkUploadModal/bulkUploadModalTypes'
// @end

// @import types
// @end

class BulkUploadService {

  private token: string
  private storeObject: any
  private Http: any

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor () {
    this.Http = Http
    this.storeObject = store
    this.token = this.storeObject.getState().auth?.user?.token
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  uploadFile = async (data: any, enpoint: IBulkUploadEndpoint) => {
    this.refreshAuthToken()

    let responseData: any
    const formData = new FormData()

    if (enpoint.params) {
      for (const key in enpoint.params) {
        if (Object.prototype.hasOwnProperty.call(enpoint.params, key)) {
          const element = enpoint.params[key];
          formData.append(key, element)
        }
      }
    }

    Object.keys(data).map((key: string) => {
      if (typeof data[key] === 'object' && !!data[key][0]?.name && !!data[key][0].type) {
        formData.append(key, data[key][0])
      } else if (typeof data[key] === 'object' && !(data[key] instanceof Array)) {
        formData.append(key, JSON.stringify(data[key]))
      } else {
        formData.append(key, data[key])
      }
      return true
    })

    const queryData: HttpCustomStructure = {
      method: enpoint.method,
      url: enpoint.url,
      headers: new Headers({
        Accept: 'application/json, application/xml, text/plain, text/html, *.*',
        'Content-Type': 'multipart/form-data',
      }),
      auth_token: this.token,
      params: formData,
    }

    responseData = await this.Http.send(queryData)
    return responseData
  }

}

export default BulkUploadService
